import React, { useEffect, useState } from 'react'
import { fetchAppInfo } from '../../network/service';
import parse from "html-react-parser";
import Loading from '../../Components/Loading/Loading';
import { ToastContainer, toast } from "react-toastify";
import Translate from '../../Components/Multilanguage/Translate';


const Faq = () => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const getFaqHtml = (value) => {
    if (typeof value === "string") return value;
    if (value === null || value === undefined) return "";
    if (typeof value === "number" || typeof value === "boolean") return String(value);
    if (typeof value === "object") {
      return value?.value || value?.content || value?.description || "";
    }
    return "";
  };

  const hasFaqContent = (value) => {
    const html = getFaqHtml(value);
    const plainText = html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, "")
      .trim();
    return plainText.length > 0;
  };

  useEffect(() => {
    window.scroll(0,0)
    fetchAboutUs();
  }, []);

  const fetchAboutUs = async () => {
    setLoading(true)
    try{
      const params = {
        type: "FAQ",
      };
      const response = await fetchAppInfo(params);
      if (response?.status === 200) {
        setData(getFaqHtml(response?.data?.data?.value));
        setLoading(false);

      }
    }catch(err){
      setLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "bottom-center",
      });
    }
    
  };

  if(loading){
    return(
      <Loading/>
    )
  }

  return (
    <div className="aboutUs">
      <ToastContainer/>
      <div className="wrapper">
        {hasFaqContent(data) ? (
          parse(getFaqHtml(data))
        ) : (
          <p><Translate textKey={'no_data_found'} /></p>
        )}
      </div>
      {/* <div dangerouslySetInnerHTML={{__html: '<strong>strong text</strong>'}} /> */}
    </div>
  )
}

export default Faq
